import { render, staticRenderFns } from "./fa-search.vue?vue&type=template&id=1df7fee5&"
import script from "./fa-search.vue?vue&type=script&lang=js&"
export * from "./fa-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports